import styled from "styled-components";
import colors from "../../common/components/ui/colors";
import { media } from "../../common/components/ui/utils";

const Languages = styled.div`
  svg {
    fill: ${colors.BRAND_GREEN};
    width: 1.5rem;
    height: 1.5rem;
    margin: 0 0.5rem;
  }
  ${media.tabletNarrow`
    margin-top: 1rem;

    svg {
      margin-left: 0;
    }
  `};
`;

const Details = styled.ul`
  display: flex;
  justify-content: space-between;
  max-width: 768px;
  width: 100%;
  margin: 0 auto;
  padding-left: 0;
  list-style:none;
  flex-flow: column;
  align-items: flex-start;
  ${media.phoneWide`
    margin-top: 1rem;
    flex-flow: row;
    
    svg {
      margin-left: 0;
    }
  `} svg {
    max-height: 3rem;
    ${media.tabletNarrow`
      max-height: 6rem;
    `};
    max-width: 4rem;
  }
`;

const Detail = styled.li`
  display: flex;
  justify-content: center;
`;

const DetailText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 1em;
`;

const DetailLabel = styled.span`
  font-family: "Roboto";
  font-size: 1rem;
  ${media.tabletNarrow`
    font-size: 1.25rem;
  `};

  flex-wrap: nowrap;
`;

const DetailValue = styled.span`
  font-weight: 400;
  font-size: 1.25rem;
  ${media.tabletNarrow`
    font-size: 2rem;
  `};
  line-height: 1em;
`;

const CalendarTitle = styled.h3`
  font-size: 24px;
  color: ${colors.BRAND_GREEN};
  margin-bottom: 14px;
  text-align: left;
  text-transform: uppercase;

  &.center {
    text-align: center;
  }
`;

const NoAvailableTimes = styled.span`
  margin-top: 3rem;
  color: ${colors.GRAY_DARK};
  text-align: center;
  display: block;
`;

const CalendarWrapper = styled.section`
  position: relative;
  width: 100%;
  
  &:after {
    content: "";
    display: table;
    clear: both;
  }
  
  ul {
    list-style:none;
    margin-left: 0;
  }
`;

const CalendarSection = styled.section`

  width: 100%;
  
  ${media.tabletNarrow`
    &.calendar-left-col {
      float: left;
      width: 50%;
      //padding-right: 5.25rem;
      padding-right: 1.5625rem;
      box-sizing: border-box;
    }
    
    &.calendar-right-col {
      float: right;
      width: 50%;
    }
  `}
  
  ${media.notTabletNarrow`
    &.calendar-left-col {
      margin-bottom: 2rem;
    }
  `}
`;

const CalendarLoaderContainer = styled.div`
  ${props => !props.isLoading && (`
    display: none;
  `)}
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(255,255,255,.5);
  z-index: 1;
`;

const VirtualCalendarScroller = styled.div`
  visibility: hidden;
  position: absolute;
`;

const CalendarSelectLabel = styled.label`
  display: block;
  font-size: .925rem;
  margin-bottom: .5rem;
  text-align: left;
`;

const Loader = styled.p`
    padding: 50px 10px;
    text-align: center;
`

export {
  Languages,
  Details,
  Detail,
  DetailText,
  DetailLabel,
  DetailValue,
  CalendarTitle,
  NoAvailableTimes,
  CalendarWrapper,
  CalendarSection,
  CalendarLoaderContainer,
  VirtualCalendarScroller,
  CalendarSelectLabel,
  Loader,
};



// WEBPACK FOOTER //
// ./src/modules/pros/ui/index.js